import { Number as AntdNumber } from "@empglabs/backoffice-ui-kit"

const Numbers = props => {
  return <AntdNumber {...props} />
}

export default Numbers
